/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const es_auth_carousel_slide3_subtitle = /** @type {(inputs: {}) => string} */ () => {
	return `Powered by Bloque`
};

const en_auth_carousel_slide3_subtitle = /** @type {(inputs: {}) => string} */ () => {
	return `Powered by Bloque`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const auth_carousel_slide3_subtitle = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.auth_carousel_slide3_subtitle(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("auth_carousel_slide3_subtitle", locale)
	if (locale === "es") return es_auth_carousel_slide3_subtitle(inputs)
	return en_auth_carousel_slide3_subtitle(inputs)
};
export { auth_carousel_slide3_subtitle as "auth.carousel.slide3_subtitle" }